export default __webpack_public_path__ + "static/media/screenshot_app_browse_desktop_purple.212789e6.png";